<template>
  <v-row no-gutters>
    <v-col>
      <modeling-options-row
        v-for="(item, index) in row"
        :setting="item"
        :key="index"
        @input="$emit('input', $event)"
      ></modeling-options-row>
    </v-col>
  </v-row>
</template>

<script>
import ModelingOptionsRow from '@/components/ModelingOptionsRow';
export default {
  name: 'ModelingOptionsTab',
  components: { ModelingOptionsRow },
  props: {
    row: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped></style>
